import { Location } from 'elements/MapAddress/stateInterface'

export const EMAIL_REGEX = /^[\w-.]+@([\w-]+.)+[\w-]{2,4}$/g

export const DRAWER_WIDTH = 300
export const MAP_COUNTRY_CENTER: Location = {
  lat: 39.49999999999997,
  lng: -98.35,
}
export const MAP_ZOOM_LEVEL = {
  street: 18,
  country: 5,
}

export const HEADERS_NAMES_SLUG = {
  company: 'X-Company-Slug',
  flow: 'X-Flow-Slug',
}
